import React from 'react';
import styled from 'styled-components';

import { useTranslation } from '@lt/localization';

import { CurrencyFormat, HotelStars, Link } from '@lt/components';
import { MOON } from '@lt/components/constants/symbols';

import Card from '../../../Card';
import ContentContainer from '../../../ContentContainer';
import HotelImage from '../HotelImage';

import { getFormattedDate } from '../../utils';

import { RELINKING_VARIANTS } from '../../../../constants';
import type { IHotelRelinkingBlock } from './types';

export const HotelRelinkingBlock = (props: IHotelRelinkingBlock) => {
  const { isMobile, image, stars, rating, name, place, country, offer } = props;
  const {
    price,
    link,
    start_date: startDate,
    end_date: endDate,
    nights,
    adults,
  } = offer;

  const { t } = useTranslation();

  const startDateString = getFormattedDate(startDate);
  const endDateString = getFormattedDate(endDate);

  const hotelUrl = `${link}&ref_content=main_page`;

  return (
    <Card $isMobile={isMobile} $variant={RELINKING_VARIANTS.HOTELS}>
      <StyledLink href={hotelUrl}>
        <HotelImage image={image} rating={rating} country={country} />
        <ContentContainer $variant={RELINKING_VARIANTS.HOTELS}>
          <div>
            <HotelStars value={stars} size={8} />
            <StyledHotelName>{name}</StyledHotelName>
            <StyledHotelPlace>
              {place}, {country}
            </StyledHotelPlace>
          </div>

          <div>
            <StyledHotelPrice>
              {t('filters.prices.from')}
              <StyledCurrencyFormat
                value={price}
                currencyCode="RUB"
                prefix=" "
              />
            </StyledHotelPrice>
            <StyledSearchParamsText>
              {startDateString} — {endDateString}, {nights}
              {MOON} {t('homeRelinking.hotels.adults', { count: adults })}
            </StyledSearchParamsText>
          </div>
        </ContentContainer>
      </StyledLink>
    </Card>
  );
};

const StyledLink = styled(Link)`
  color: #17181a;
  display: block;
`;

const textOverflowStyles = `
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

const StyledHotelName = styled.p`
  margin-top: 4px;

  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
  ${textOverflowStyles}
`;

const StyledHotelPlace = styled.p`
  ${textOverflowStyles}
  font-size: 12px;
`;

const StyledHotelPrice = styled.p`
  font-weight: 700;
  margin-top: 4px;
`;

const StyledCurrencyFormat = styled(CurrencyFormat)`
  font-size: 18px;
  line-height: 22px;

  display: block
  margin: 4px 0;
`;

const StyledSearchParamsText = styled.p`
  font-size: 12px;
  color: #4d4d4d;
`;
